import { FC } from 'react';

import dayjs from 'dayjs';
import { CalendarDays } from 'lucide-react';
import { isNullish } from 'remeda';

import css from './Activity.module.css';

import { ProfileCard } from 'v2/components/profileCard/ProfileCard';
import { LONG_DASH } from 'v2/constants';
import { UserModel } from 'v2/types/UserModel';
import { UserStatisticDto } from 'v2/types/UserProfileModel';

type UserWithDropSettings = UserModel & {
  dropSettings?: { lastRollDate?: string | null };
};

interface ActivityProps {
  user: UserModel;
  stats?: UserStatisticDto;
}

export const Activity: FC<ActivityProps> = ({ user, stats }) => {
  const formatDate = (date?: string | null) =>
    isNullish(date) || date === '' ? LONG_DASH : dayjs(date).format('YYYY-MM-DD');

  const extended = user as UserWithDropSettings;

  const lastFortuneWheelDate = extended.dropSettings?.lastRollDate ?? user.lastSpecialDropRollDate;

  return (
    <ProfileCard title="Activity" icon={<CalendarDays width={18} height={18} />}>
      <div className={css.statsGrid}>
        <div className={css.statRow}>
          <span className={css.statLabel}>LAST PROMO CODE</span>

          <span className={css.statValue}>{formatDate(user.lastPromocodeUseDate)}</span>
        </div>

        <div className={css.statRow}>
          <span className={css.statLabel}>LAST FORTUNE WHEEL</span>

          <span className={css.statValue}>{formatDate(lastFortuneWheelDate)}</span>
        </div>

        <div className={css.statRow}>
          <span className={css.statLabel}>DAILY TASKS COMPLETED</span>

          <span className={css.statValue}>{stats?.completedTasks ?? LONG_DASH}</span>
        </div>
      </div>
    </ProfileCard>
  );
};
